
import { useState } from 'react';

interface ShareButtonsProps {
  title: string;
  slug: string;
}

export default function ShareButtons({ title, slug }: ShareButtonsProps) {
  const [copied, setCopied] = useState(false);
  const articleUrl = `${window.location.origin}/blog/${slug}`;
  const encodedUrl = encodeURIComponent(articleUrl);
  const encodedTitle = encodeURIComponent(title);

  const handleCopyLink = () => {
    // Gracefully handle clipboard API availability
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(articleUrl).catch(() => {
        // Fallback for browsers that reject the promise
        const textarea = document.createElement('textarea');
        textarea.value = articleUrl;
        textarea.style.position = 'fixed';
        document.body.appendChild(textarea);
        textarea.select();
        document.execCommand('copy');
        document.body.removeChild(textarea);
      });
    } else {
      // Legacy fallback
      const textarea = document.createElement('textarea');
      textarea.value = articleUrl;
      textarea.style.position = 'fixed';
      document.body.appendChild(textarea);
      textarea.select();
      document.execCommand('copy');
      document.body.removeChild(textarea);
    }

    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  return (
    <section className="py-8 bg-white border-t border-slate-100">
      <div className="max-w-3xl mx-auto px-6 lg:px-8">
        <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-slate-600 font-medium">Share this article</p>
          <div className="flex items-center gap-3">
            <a
              href={`https://twitter.com/intent/tweet?url=${encodedUrl}&text=${encodedTitle}`}
              target="_blank"
              rel="noopener noreferrer"
              className="w-10 h-10 flex items-center justify-center bg-slate-100 rounded-full text-slate-600 hover:bg-[#00989e] hover:text-white transition-all cursor-pointer"
            >
              <i className="ri-twitter-x-line"></i>
            </a>
            <a
              href={`https://www.linkedin.com/sharing/share-offsite/?url=${encodedUrl}`}
              target="_blank"
              rel="noopener noreferrer"
              className="w-10 h-10 flex items-center justify-center bg-slate-100 rounded-full text-slate-600 hover:bg-[#00989e] hover:text-white transition-all cursor-pointer"
            >
              <i className="ri-linkedin-fill"></i>
            </a>
            <a
              href={`https://www.facebook.com/sharer/sharer.php?u=${encodedUrl}`}
              target="_blank"
              rel="noopener noreferrer"
              className="w-10 h-10 flex items-center justify-center bg-slate-100 rounded-full text-slate-600 hover:bg-[#00989e] hover:text-white transition-all cursor-pointer"
            >
              <i className="ri-facebook-fill"></i>
            </a>
            <button
              onClick={handleCopyLink}
              className="w-10 h-10 flex items-center justify-center bg-slate-100 rounded-full text-slate-600 hover:bg-[#00989e] hover:text-white transition-all cursor-pointer relative"
            >
              <i className={`ri-${copied ? 'check' : 'link'}-line`}></i>
              {copied && (
                <span className="absolute -top-10 left-1/2 -translate-x-1/2 px-3 py-1 bg-slate-800 text-white text-xs rounded-lg whitespace-nowrap">
                  Copied!
                </span>
              )}
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}
